var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.551 120.162C82.6639 118.908 89.4602 116.265 95.5518 112.385C101.643 108.504 106.911 103.461 111.054 97.5447C115.196 91.6283 118.133 84.9537 119.697 77.9022C121.26 70.8507 121.419 63.5604 120.165 56.4474C118.911 49.3344 116.268 42.5381 112.387 36.4466C108.506 30.355 103.463 25.0875 97.547 20.9447C91.6305 16.8019 84.956 13.865 77.9045 12.3018C70.853 10.7385 63.5626 10.5794 56.4496 11.8336C49.3367 13.0878 42.5404 15.7308 36.4488 19.6115C30.3573 23.4923 25.0897 28.5349 20.9469 34.4514C16.8042 40.3678 13.8673 47.0424 12.304 54.0939C10.7407 61.1454 10.5817 68.4357 11.8359 75.5487C13.0901 82.6617 15.733 89.458 19.6138 95.5495C23.4945 101.641 28.5371 106.909 34.4536 111.051C40.3701 115.194 47.0446 118.131 54.0961 119.694C61.1476 121.258 68.438 121.417 75.551 120.162L75.551 120.162Z",
    stroke: "url(#paint0_linear_4157_13632)",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66 66L66 99",
    stroke: "#BE1E2D",
    strokeWidth: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66 38.502L66 33.002",
    stroke: "#BE1E2D",
    strokeWidth: 10,
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4157_13632",
    x1: 11.0003,
    y1: 10.9981,
    x2: 139.43,
    y2: 91.6498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE1E2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.2afc151bd8c52f26d75bb02c4b753fd1.svg";
export { ForwardRef as ReactComponent };